import { render, staticRenderFns } from "./normalized-img.vue?vue&type=template&id=6d11e1d4&lang=pug"
import script from "./normalized-img.vue?vue&type=script&lang=coffee"
export * from "./normalized-img.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports